import React from 'react';
import { graphql } from 'gatsby';
import HeaderMain from '../components/HeaderMain';
import Footer from '../components/Footer';
import HeroSingle from '../components/pages/HeroSingle';
import SEO from '../components/seo';
import '../styles/app.scss';

const pfr = ({ data }) => {
    const { wordpressPage: post } = data;
    console.log(post);
    const test_title = post.yoast_title;
    const new_test_title = test_title.replace('&#039;', "'");
    const inlineCss = {
        maxWidth: '600px',
        marginTop: '50px',
    };
    return (
        <>
            <SEO
                title={new_test_title}
                meta={post.yoast_meta}
                description={
                    post.yoast_json_ld[0].wordpress__graph[0].description
                }
            />
            <HeaderMain />
            <HeroSingle pageTitle={post.title} />

            <section className="page-section smallestwdt centersec">
                <div className="container">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: post.content,
                        }}
                    />
                </div>
            </section>
            <section className="whywelist page-section bg-primary text-white">
                <div className="container flexwrap whywebluelist" style={{ marginBottom: '50px' }}>
                    <div className="whylistlft flexbox whylisttxt todwn">
                        <img
                            className="whiteborderimg"
                            src={
                                "https://werockthespectrumpiscataway.wrtsfranchise.com/wp-content/uploads/2026/10/Seamless-gym-swing-scene-cleanup.jpg"
                            }
                            style={{ maxHeight: '1000px' }}
                            loading="lazy"
                            alt="open img"
                        />
                    </div>

                    <div className="whylistrgt flexbox toup">
                        <h2 className="yellowtxt">Rockin' Group Play</h2>
                    <p style={{ marginTop: '30px' }}>Gather your friends for two hours of fun during Open Play! Your group will share the sensory gym with other guests.</p> 
                    <ul className="startxt starlistspacing" style={{ marginTop: '30px', textAlign: 'left' }}>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>$160 for up to 10 children.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Two-hour session.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Additional children: $16 each.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Maximum of 15 children per group.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>$160 minimum per group, even if fewer than 10 children attend.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Accompanying adults included, subject to facility occupancy limits.</li>
                    </ul>
                    <p>Party room access, reserved seating, food, cake, decorations, and party setup are not included or permitted with this package.</p>
                    <p>Advance booking is required. Weekend availability is released up to 14 days ahead during selected confirmed Open Play sessions.</p>
                    <div
                        className="bookawrap"
                        style={{ maxWidth: '500px', margin: 'auto', width: '100%' }}
                    >
                        <a
                            className="wrtsbtn yellowbtn fullbtn"
                            href="#contformsec"
                        >
                            Check Group Play Availability
                        </a>
                </div> 
                    </div>                    
                </div> 
                        
                <div className="container flexwrap whywebluelist" style={{ marginBottom: '50px' }}>
                    <div className="whylistlft flexbox whylisttxt todwn">
                        <img
                            className="whiteborderimg"
                            src={
                                "https://werockthespectrumpiscataway.wrtsfranchise.com/wp-content/uploads/2026/10/Kids-Exploring-a-Sensory-Gym.webp"
                            }
                            style={{ maxHeight: '1000px' }}
                            loading="lazy"
                            alt="open img"
                        />
                    </div>

                    <div className="whylistrgt flexbox toup">
                        <h2 className="yellowtxt">Rockin' Private Play</h2>
                    <p style={{ marginTop: '30px' }}>Enjoy exclusive use of our sensory gym with your small group of friends or family!</p> 
                    <ul className="startxt starlistspacing" style={{ marginTop: '30px', textAlign: 'left' }}>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>60 minutes: $160 for up to 5 children.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>90 minutes: $200 for up to 5 children.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Additional children: $15 each.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Maximum of 10 children per booking.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Accompanying adults included, subject to facility occupancy limits.</li>
                    </ul>
                    <p>Includes exclusive sensory gym access and staff assistance with equipment use. Party room access is not included. Food, cake, decorations, and party setup are not permitted.</p>
                    <p>Available by inquiry during selected off-peak times. Select weekend openings may be released up to 7 days ahead. All sessions require confirmation from our team.</p>
                    <div
                        className="bookawrap"
                        style={{ maxWidth: '500px', margin: 'auto', width: '100%' }}
                    >
                        <a
                            className="wrtsbtn yellowbtn fullbtn"
                            href="https://werockthespectrumpiscataway.com/contact-us/"
                            target="_blank"
                        >
                            Request Private Play Availability
                        </a>
                </div>  
                    </div>                    
                </div>  
                
                <div className="container smallestwdt">
                    <h2 className="yellowtxt">Private Group Events</h2>
                    <p>Host a family engagement event, organization outing, or community gathering in our inclusive sensory gym.</p>
                    <p>Private weekend events start at $650 for two hours and up to 20 children, with accompanying adults included. Includes exclusive sensory gym access and staff assistance.</p>
                    <p>Final pricing depends on attendance, duration, activities, and support needs. Room access, refreshments, and organized activities can be discussed when requesting a quote.</p>          
                    <p>Available by advance inquiry, subject to scheduling and facility capacity.</p>
                </div>    
                <div
                        className="bookawrap"
                        style={{ maxWidth: '500px', margin: 'auto', width: '100%' }}
                    >
                        <a
                            className="wrtsbtn yellowbtn fullbtn"
                            href="https://werockthespectrumpiscataway.com/contact-us/"
                            target="_blank"
                        >
                            Request an Event Quote
                        </a>
                </div>    
            </section>
            <section className="whywelist page-section bg-secondary text-white">
                <div className="container smallestwdt" style={{ maxWidth: '800px' }}>
                    <h2 className="yellowtxt">Important Visit Information</h2>
                {/*    <p style={{ marginTop: '30px' }}><strong>School’s Out Camp is available for children:</strong></p> */}
                    <ul className="startxt starlistspacing" style={{ marginTop: '30px', textAlign: 'left' }}>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Parents or designated caregivers must remain onsite and supervise their children. These are not drop-off programs.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Required waivers must be completed before participation.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Children must wear grippy socks. Adults must wear socks on the gym floor. Grippy socks are available for purchase.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>All participating children, including siblings, must be included in the booking.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Our maximum occupancy is 60 people, including children, adults, and staff.</li>
                        <li className="whitetxt" style={{ textTransform: 'none', fontFamily: 'gothambook' }}>Late arrival does not extend the reserved session.</li>
                    </ul>
                   {/* <h3 className="yellowtxt" style={{ marginTop: '30px' }}>Membership & Cancellation Terms</h3> 
                    <p style={{ marginTop: '30px' }}>If a child requires continuous one-to-one assistance, the family should contact us before registering to discuss available participation options.</p> */}
                </div>
            </section>
            <section className="page-section smallestwdt respitesec">
                <div className="container text-center">
                    <h2 className="bluetxt" style={{ marginBottom: '30px', textAlign: 'center' }}>See Our Other Programs</h2>
                    <p>Looking for a celebration with party room access and party amenities?</p>
                    <div
                        className="bookawrap"
                        style={{ maxWidth: '500px', margin: 'auto', width: '100%', marginTop: '30px', marginBottom: '50px' }}
                    >
                        <a
                            className="wrtsbtn yellowbtn fullbtn"
                            href="https://werockthespectrumpiscataway.com/birthday-parties-private-playdates/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Explore our Birthday Party Packages
                        </a>
                    </div>
                    <p>Planning a school or community-based instructional outing?</p>
                    <div
                        className="bookawrap"
                        style={{ maxWidth: '500px', margin: 'auto', width: '100%', marginTop: '30px' }}
                    >
                        <a
                            className="wrtsbtn yellowbtn fullbtn"
                            href="https://werockthespectrumpiscataway.com/field-trips/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Explore our Field Trips
                        </a>
                    </div>
                </div>
            </section>
            <section className="whywelist page-section bg-primary text-white" id="contformsec">
                <div className="container smallestwdt">
              {/*      <h2 className="yellowtxt">READY TO PLAN YOUR VISIT?</h2>
                    <p>Tell us about your group and we’ll help you determine the best field trip option.</p> */}
                    <div className="container flexwrap contactform_wrap">
                        <iframe style={{ minHeight: '490px' }}
                            src="https://werockthespectrumpiscataway.wrtsfranchise.com/private-facility-rentals/"
                            title="contactform"
                        />                    
                    </div>  
                    <p><i>Please note that submitting the form does not confirm a reservation. </i></p>                  
                </div>
            </section>
            
            <Footer />
        </>
    );
};

export default pfr;

export const pageQuery = graphql`
    query($id: String!) {
        wordpressPage(id: { eq: $id }) {
            id
            title
            slug
            content            
            yoast_meta {
                name
                property
            }
            yoast_title
            yoast_json_ld {
                wordpress__graph {
                    description
                }
            }
        }
    }
`;
